import React from 'react';
import {connect} from "react-redux";
import './filterModal.css';
import Datetime from "react-datetime";
import calendar from "../../assets/reports/cal.png";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import editIcon from "../../assets/edit-icon.svg";
import SVG from "react-inlinesvg";

class DateFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            search_terms: {},
            from_date: false,
            from_date_format: false,
            to_date: false,
            to_date_format: false,
            sort: "newest",
        };
    }
    componentDidMount() {
        let options = this.props.options;
        let search_terms = this.props.filterItems;
        // let arr = [];
        // let obj = {};
        let to_date = "";
        let from_date = "";
        let sort = "newest";
        if(search_terms !== undefined && search_terms.length > 0){
            search_terms = search_terms.filter(st => {
                if (st.type === 'filter_from_date_format') {
                    from_date = st.name;
                }
                if(st.type === "filter_to_date_format"){
                    to_date = st.name
                }
                if(st.type === "filter_sort"){
                    sort = st.name;
                }
            });
        }
        // options = options.map(o => {
        //     if(o.selected === undefined){
        //         o['selected'] = true;
        //     }
        //     arr.push(o.name);
        //     obj[o.type] = arr;
        //     return o;
        // })

        this.setState(prevState => ({
            options,
            from_date: from_date,
            to_date: to_date,
            from_date_format: from_date,
            to_date_format: to_date,
            sort: sort
        }));
    }
    handleDateChange = (moment, name) => {
        if (typeof moment.format === 'function') {
            let inputValues = {};
            inputValues[name] = moment;
            inputValues[name + '_format'] = moment.format('MMMM YYYY');
            if(name === 'to_date'){
                inputValues[name + '_format'] = moment.endOf('month').format('MMMM YYYY');
            }
            if (name === 'from_date') {
                inputValues['to_date'] = false;
                inputValues['to_date_format'] = false;
            }
            this.setState({
                ...inputValues
            });
        }
    }
    handleOptionChange = (changeEvent) => {
        this.setState({
            sort: changeEvent.target.value
        });
    }

    applyFilters = () => {
        let search_terms = {
            filter_from_date_format: moment(this.state.from_date_format).format('YYYY-MM-DD'),
            filter_to_date_format: moment(this.state.to_date_format).endOf('month').format('YYYY-MM-DD'),
            filter_sort: this.state.sort,
        };
        if(!this.state.from_date_format){
            search_terms = {
                filter_sort: this.state.sort,
            }
        }
        this.props.setSearchTerms(search_terms, false);
    }

    render(){
        const dateToStore = '2016-09-01 12:00';
        const momentDate = moment(dateToStore, 'YYYY-MM-DD HH:mm');

        let valid = function (current) {
            return current.isAfter(momentDate);
        };

        let validEndDate = (current) => {
            return current.isAfter(this.state.from_date);
        };

        return(
            <div className="search-filter-modal date-filter-modal" ref={this.props.innerRef}>
                <div className="date-row-1">
                    <span>Sort by:</span>
                    <div className="date-radio-btn-container">
                        <label htmlFor="newest">
                            <input type="radio"  id="newest" value="newest"  name="sort-date"  onChange={this.handleOptionChange}  checked={this.state.sort === "newest"}/>
                            Newest
                        </label>
                        <label htmlFor="oldest">
                            <input type="radio" id="oldest" value="oldest" name="sort-date"  onChange={this.handleOptionChange}  checked={this.state.sort === "oldest"}/>
                            Oldest
                        </label>
                    </div>
                </div>
                <div className="date-input-containers">
                    <div className="export-column export-end">
                        <div className="filter-date-icons cal"><img src={calendar} alt=""/></div>
                        <label>Start Date</label>
                        <Datetime
                            dateFormat={"MMMM YYYY"}
                            value={this.state.from_date_format}
                            className="form-control"
                            name="from_date"
                            onChange={moment => this.handleDateChange(moment, 'from_date')}
                            inputProps={{readOnly: true}}
                            closeOnSelect={true}
                            isValidDate={valid}
                        />
                        {/*<div className="report-icons cal"><img src={calendar} alt=""/></div>*/}
                    </div>
                    <div className="export-column export-end">
                        <div className="filter-date-icons cal"><img src={calendar} alt=""/></div>
                        <label>End Date</label>
                        <Datetime
                            dateFormat={"MMMM YYYY"}
                            value={this.state.to_date_format}
                            className="form-control"
                            name="to_date"
                            onChange={moment => this.handleDateChange(moment, 'to_date')}
                            inputProps={{readOnly: true}}
                            closeOnSelect={true}
                            isValidDate={validEndDate}
                        />
                        {/*<div className="report-icons cal"><img src={calendar} alt=""/></div>*/}
                    </div>
                </div>
                <div className="filter-btn-container">
                    <button
                        // className={`apply--btn ${this.state.sort !== "newest" ? !this.state.to_date ? 'disable' : '' : 'disable'}` }
                        className={`apply--btn` }
                        // disabled={this.state.sort === "newest" ? !this.state.to_date : false}
                        onClick={this.applyFilters}>Apply Filters!</button>
                </div>
            </div>
        )
    }

}

export default connect(null)(DateFilter);